import APIClient, { failSafe, makeCancellableAPIRequest } from "restAPI";

const SubProductEnvironmentTypeAPI = {
    get(id) {
        return failSafe(
            APIClient.get(`/user/sub-product-environment-type/${id}`)
        )
    },
    update(data) {
        return makeCancellableAPIRequest(
            "PUT",
            `/user/sub-product-environment-type`,
            {
                data,
            }
        )
    },
    v2: {
        getAll(subProductId){
            return makeCancellableAPIRequest(
                "GET",
                `/user/environment/elastic/`,
                {
                    params: { subProductId },
                }
            )
        }
    },
    getAllQuick(subProductId){
        return makeCancellableAPIRequest(
            "GET",
            `/user/environment/elastic/short`,
            {
                params: { subProductId },
            }
        )
    },
    getByBU(buId, apId, aspId){
        return makeCancellableAPIRequest(
            "GET",
            `/api/tenant/businessUnits/${buId}/products/${apId}/subProducts/${aspId}/environments`,
        )
    }
}

export default SubProductEnvironmentTypeAPI;